<template>
    <v-dialog v-model="value" max-width="500px">
        <v-card>
            <v-toolbar>
                <v-toolbar-title v-if="loading">Laster...</v-toolbar-title>
                <v-toolbar-title v-else>Kundegrupper</v-toolbar-title>
            </v-toolbar>

            <v-card-text v-if="loading">
                <v-progress-linear indeterminate/>
            </v-card-text>
            <div v-else>
                <v-layout v-for="category in categories" class="pa-2" :key="category.id">
                    <v-text-field solo v-model="category.name" class="mr-2"/>
                    <v-btn color="red" @click="remove(category)" dark icon>
                        <v-icon>delete</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="save(category)" dark icon>
                        <v-icon>save</v-icon>
                    </v-btn>
                </v-layout>
                <v-layout class="pa-2 grey lighten-2">
                    <v-text-field solo placeholder="Ny kundegruppe" v-model="newCategoryName" class="mr-2"/>
                    <v-btn color="green" @click="create" dark>Legg til</v-btn>
                </v-layout>
                <v-card-actions>
                    <v-btn color="red" text @click="close">
                        <v-icon left>close</v-icon>
                        Lukk
                    </v-btn>
                    <v-spacer/>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import CustomerSearch from './CustomerSearch';

    export default {
        components: {
            CustomerSearch
        },

        props: ['value'],

        data() {
            return {
                loading: false,
                categories: [],
                newCategoryName: '',
            }
        },

        created() {
        },

        methods: {
            loadData() {
                this.loading = true;
                this.$http.get(`customer-categories`).then(response => {
                    this.categories = response.data.data;
                }).finally(() => this.loading = false);
            },
            close() {
                this.$emit('input', false);
            },
            create() {
                this.loading = true;
                this.$http.post(`customer-categories`, {name: this.newCategoryName}).then(response => {
                    this.newCategoryName = '';
                    this.loadData();
                    this.$emit('create', response.data.data.id);
                });
            },
            save(category) {
                this.loading = true;

                this.$http.put(`customer-categories/${category.id}`, category).then(response => {
                    this.loadData();
                }).catch(() => {
                    this.loading = false;
                });
            },
            remove(category) {
                let ok = confirm('Vil du virkelig slette denne kundegruppen? Handlingen kan ikke angres.');
                if (!ok) return;

                this.loading = true;
                this.$http.delete(`customer-categories/${category.id}`).then(response => {
                    this.loadData();
                }).catch(() => {
                    this.loading = false;
                })
            }
        },

        watch: {
            value() {
                if (this.value) {
                    this.loadData();
                }
            },

            customerId() {
                this.car.customer_id = this.customerId || null;
            }
        },

        computed: {
            isNewCar() {
                return !this.carId;
            }
        }
    }
</script>
